module.exports = __webpack_public_path__ + "static/media/soda.fb0b5006.webp";